import { initializeDB } from '../config/db';
import { OPERATOR_PRACTICAL_EVALUATION_STORE } from '../config/constants';
import axiosInstance from '../axiosInstance';

const operatorPracticalEvaluationService = {
    // IndexedDB operations
    async saveToIndexedDB(evaluation) {
        try {
            const db = await initializeDB();
            const tx = db.transaction([OPERATOR_PRACTICAL_EVALUATION_STORE], 'readwrite');
            const store = tx.objectStore(OPERATOR_PRACTICAL_EVALUATION_STORE);
            await store.put(evaluation);
            await tx.done;
            console.log('Operator Practical Evaluation saved to IndexedDB:', evaluation.uuid);
            return evaluation;
        } catch (error) {
            console.error('Error saving to IndexedDB:', error);
            throw error;
        }
    },

    async getFromIndexedDB(uuid) {
        try {
            const db = await initializeDB();
            const tx = db.transaction([OPERATOR_PRACTICAL_EVALUATION_STORE], 'readonly');
            const store = tx.objectStore(OPERATOR_PRACTICAL_EVALUATION_STORE);
            const evaluation = await store.get(uuid);
            return evaluation;
        } catch (error) {
            console.error('Error getting from IndexedDB:', error);
            throw error;
        }
    },

    async getAllFromIndexedDB() {
        try {
            const db = await initializeDB();
            const tx = db.transaction([OPERATOR_PRACTICAL_EVALUATION_STORE], 'readonly');
            const store = tx.objectStore(OPERATOR_PRACTICAL_EVALUATION_STORE);
            const evaluations = await store.getAll();
            return evaluations;
        } catch (error) {
            console.error('Error getting all from IndexedDB:', error);
            throw error;
        }
    },

    async deleteFromIndexedDB(uuid) {
        try {
            const db = await initializeDB();
            const tx = db.transaction([OPERATOR_PRACTICAL_EVALUATION_STORE], 'readwrite');
            const store = tx.objectStore(OPERATOR_PRACTICAL_EVALUATION_STORE);
            await store.delete(uuid);
            await tx.done;
            console.log('Operator Practical Evaluation deleted from IndexedDB:', uuid);
        } catch (error) {
            console.error('Error deleting from IndexedDB:', error);
            throw error;
        }
    },

    // API operations
    async submit(evaluation) {
        try {
            const response = await axiosInstance.post('/operator-practical-evaluation/submit', evaluation);
            return response.data;
        } catch (error) {
            console.error('Error submitting evaluation:', error);
            throw error;
        }
    },

    // Submit through Training Due endpoint (for Forklift training)
    async submitForTrainingDue(evaluation) {
        try {
            const response = await axiosInstance.post('/training-due/upload', {
                ...evaluation,
                formType: 'operator-practical-evaluation'
            });
            return response.data;
        } catch (error) {
            console.error('Error submitting evaluation for training due:', error);
            throw error;
        }
    }
};

export default operatorPracticalEvaluationService;
